import { useMutation, UseMutationResult, useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosResponse } from 'axios';
import {
  AuthProtocolGetInfoResponse,
  AuthProtocolLoginRequest,
  AuthProtocolLoginResponse,
  AuthProtocolOktaLoginRequest,
  AuthProtocolOktaLoginResponse,
} from '../swagger/data-contracts';
import { authApi, getAuth, IAuthData, setAuth } from './';

export const QueryKeyAuth = 'auth';
const queryOptions = { refetchOnWindowFocus: false };

export const useLoginMutation = (): UseMutationResult<
  AxiosResponse<AuthProtocolLoginResponse>,
  unknown,
  AuthProtocolLoginRequest,
  unknown
> => {
  return useMutation(authApi.loginCreate, {
    onSuccess: (response) => {
      const authData: IAuthData = {
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      };

      setAuth(authData);
    },
  });
};

export const useGetInfo = (): UseQueryResult<AuthProtocolGetInfoResponse, unknown> => {
  return useQuery(
    [QueryKeyAuth, 'get_info'],
    async () => {
      const auth = getAuth();
      if (auth.accessToken && auth.refreshToken) {
        const { data } = await authApi.infoList();
        return data;
      } else {
        return undefined;
      }
    },
    queryOptions
  );
};

export const useLoginOktaMutation = (): UseMutationResult<
  AxiosResponse<AuthProtocolOktaLoginResponse>,
  unknown,
  AuthProtocolOktaLoginRequest,
  unknown
> => {
  return useMutation(authApi.loginOktaCreate, {
    onSuccess: (response) => {
      const authData: IAuthData = {
        accessToken: response.data.accessToken,
        refreshToken: response.data.refreshToken,
      };

      setAuth(authData);
    },
  });
};
